export function initOpenChatbot(): void {
    document.addEventListener('avency.init', init, {passive: true});
    document.addEventListener('avency.reinit', init, {passive: true});
    init();
}

function init(): void {
    document.querySelectorAll('[href="#open-chatbot"]:not([data-chatbot-init="true"])').forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            // Mark the element as initialized to prevent multiple event listeners
            element.setAttribute('data-chatbot-init', 'true');

            openChatbot();
        });
        element.addEventListener('touchend', (event) => {
            event.preventDefault();

            // Mark the element as initialized to prevent multiple event listeners
            element.setAttribute('data-chatbot-init', 'true');

            openChatbot();
        });
    });
}

export function openChatbot(): void {
    // @ts-ignore
    document.getElementById('mercury-widget').open();
    document.dispatchEvent(new CustomEvent('avency.mercuryai.chatbot.opened'));
}

export function closeChatbot(): void {
    // @ts-ignore
    document.getElementById('mercury-widget').close();
    document.dispatchEvent(new CustomEvent('avency.mercuryai.chatbot.closed'));
}
